import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-optional-item-popover',
  templateUrl: './optional-item-popover.component.html',
  styleUrls: ['./optional-item-popover.component.scss']
})
export class OptionalItemPopoverComponent implements OnInit {
  @Output() skipItem = new EventEmitter();
  @Output() startCurrentItem = new EventEmitter();
  @Output() hideOptionalModal = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  skipCurrentItem() {
    this.skipItem.emit(true);
  }

  startCurrentItemEvent() {
    this.startCurrentItem.emit(true);
  }

  hideModal() {
    this.hideOptionalModal.emit(false);
  }

}
